import React from 'react'
import ThumbItem from './ThumbItem'

function mapListing(item, index) {
  const {limit} = this
  if (index >= limit) { return '' }
  const finalProps = Object.assign({...this}, {key: `${item.id}-${index}`, item: item})
  return <ThumbItem {...finalProps} />
}

const ThumbListing = (props) => {
  const { data } = props
  let itemProps = Object.assign({}, {...props})
  delete itemProps.data
  return (
    <div className="list thumbnail-list">
      <div className="list-wrapper">
        <div className="row">
          {data.map(mapListing, {...itemProps})}
        </div>
      </div>
    </div>
  )
}

export default ThumbListing



// WEBPACK FOOTER //
// ./assets/js/components/thumbnail/ThumbListing.jsx